<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<router-outlet></router-outlet>

<div class="modal fade" id="rateLimitModal" tabindex="-1" role="dialog" aria-labelledby="rateLimitModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content text-center p-3">
      <div class="modal-header border-0">
        <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h5 class="modal-title mb-3 fw-bold">
          Too many requests. Please wait a few seconds and try again
        </h5>
        <p>Refreshing in <span id="rateLimitCountdown">60</span> seconds...</p>
      </div>
    </div>
  </div>
</div>
